"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentsInCompositions = exports.flatMap = exports.isNestedComposition = exports.getComponentPath = void 0;
function getComponentPath(options) {
    const { subpath, index, prefix } = options;
    const componentPath = index !== undefined ? `[${index}]${subpath}` : subpath;
    const prefixPath = prefix ? `${prefix}` : '';
    const renderPath = `${prefixPath}${componentPath}`;
    return renderPath;
}
exports.getComponentPath = getComponentPath;
function isNestedComposition(component) {
    return component.type === 'nested-composition';
}
exports.isNestedComposition = isNestedComposition;
function flatMap(collection, map) {
    return collection.reduce((acc, val, i) => {
        map(val, i).forEach(v => acc.push(v));
        return acc;
    }, []);
}
exports.flatMap = flatMap;
/** Maps an array of compositions to a flat list of components */
function getComponentsInCompositions(compositions, componentRenderPath) {
    return flatMap(compositions, (composition, i) => flatMap(Object.keys(composition.contentAreas), key => contentAreas(composition, i, key, componentRenderPath !== undefined, componentRenderPath)));
}
exports.getComponentsInCompositions = getComponentsInCompositions;
/** Takes an array of compositions, and expands any nested compostions
 * into a flat list of components
 */
function expandNestedCompositionsIntoComponents(components, componentRenderPath) {
    const contentAreasArr = [];
    components.forEach((c, i) => {
        if (isNestedComposition(c)) {
            const props = c.props;
            const result = getComponentsInCompositions([props.composition], `${componentRenderPath}/[${i}]`);
            result.forEach(col => contentAreasArr.push(col));
        }
        else {
            contentAreasArr.push({ ...c, componentRenderPath: `${componentRenderPath}/[${i}]` });
        }
    });
    return contentAreasArr;
}
// map the content areas from the given composition
function contentAreas(composition, i, contentAreaKey, innerSearch, componentRenderPath) {
    const routeDataOptions = {
        subpath: !innerSearch ? composition.type : 'nested:' + composition.type,
        index: !innerSearch ? i : undefined,
        prefix: componentRenderPath,
    };
    const components = composition.contentAreas[contentAreaKey];
    const path = `${getComponentPath(routeDataOptions)}/${contentAreaKey}`;
    return expandNestedCompositionsIntoComponents(components, path);
}
//# sourceMappingURL=helpers.js.map